import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'

export const renderReportReason = (item) => (
  <Translate>
    {(t) => (
        <div className="flex flex-col">
          <span className="font-semibold text-primary">{getTitle(item)}</span>
          <span className="text-xs text-color-400 italic">{item?.description}</span>
        </div>
    )}
  </Translate>
)
